/*
  Gift card PDP: mirror the selected variant's price into the Giftnote voucher
  button, so "SEND TO A FRIEND" reads like "ADD TO BAG – $150".

  The button lives in an open shadow root built by the app's CDN bundle. It sets
  its label from data-label once, in the constructor, and never observes it
  again -- so both the label text and the layout overrides have to be written
  into the shadow root directly.
*/
(function () {
  var SHADOW_STYLE_ID = 'halfdays-giftcard-cta';
  var FALLBACK_LABEL = 'SEND TO A FRIEND';

  function priceEl() {
    return document.querySelector('.button_add_to_cart_new [data-price] [data-regular-price]');
  }

  function separator() {
    var dash = document.querySelector('.button_add_to_cart_new .dash_new');
    return dash ? dash.textContent : ' – ';
  }

  function applyShadowStyles(host) {
    if (host.shadowRoot.getElementById(SHADOW_STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = SHADOW_STYLE_ID;
    style.textContent = [
      '#button { margin-top: 0; }',
      '@media screen and (max-width: 740px) { #button { width: 100%; } }'
    ].join('\n');

    // Appended last so it outranks the app block's own custom CSS, which lands
    // in the shadow root during the constructor.
    host.shadowRoot.appendChild(style);
  }

  function render() {
    var host = document.querySelector('giftnote-voucher-button');
    if (!host || !host.shadowRoot) return;

    applyShadowStyles(host);

    var label = host.shadowRoot.getElementById('add');
    var price = priceEl();
    if (!label || !price) return;

    label.textContent =
      (host.dataset.label || FALLBACK_LABEL) + separator() + price.textContent.trim();
  }

  var price = priceEl();
  if (price) {
    new MutationObserver(render).observe(price, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  // Covers the app bundle loading after this script...
  document.addEventListener('giftnote_hydrate', render);
  // ...and the element already being upgraded by the time we run.
  render();
})();
